/**
 * Scope 3 Service — Business Travel (Cat 6), Employee Commute (Cat 7),
 * factor catalog, and activity CRUD.
 *
 * Uses native fetch() directly (not axios) so it doesn't go through the
 * global axios interceptor chain — that has caused past phantom failures.
 */
import { getToken } from './authService';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API_URL = `${BACKEND}/api/scope3`;

function authHeaders(extra = {}) {
  const t = getToken();
  const h = { ...extra };
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
}

async function handleResponse(res) {
  const contentType = res.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const body = isJson ? await res.json().catch(() => ({})) : await res.text().catch(() => '');
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.response = { status: res.status, data: body };
    err.status = res.status;
    err.detail = isJson ? body?.detail : body;
    throw err;
  }
  return body;
}

export const listFactors = async ({ ghg_category, mode, activity_unit } = {}) => {
  const q = new URLSearchParams();
  if (ghg_category != null) q.append('ghg_category', ghg_category);
  if (mode) q.append('mode', mode);
  if (activity_unit) q.append('activity_unit', activity_unit);
  const res = await fetch(`${API_URL}/factors?${q.toString()}`, { headers: authHeaders() });
  return handleResponse(res);
};

export const getFactorCatalog = async ({ ghg_category } = {}) => {
  const q = ghg_category != null ? `?ghg_category=${ghg_category}` : '';
  const res = await fetch(`${API_URL}/factor-catalog${q}`, { headers: authHeaders() });
  return handleResponse(res);
};

export const calculatePreview = async (activity) => {
  const res = await fetch(`${API_URL}/calculate`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(activity),
  });
  return handleResponse(res);
};

export const saveActivity = async (activity) => {
  const res = await fetch(`${API_URL}/activities`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(activity),
  });
  return handleResponse(res);
};

export const listActivities = async ({ ghg_category, limit = 200, offset = 0 } = {}) => {
  const q = new URLSearchParams();
  if (ghg_category != null) q.append('ghg_category', ghg_category);
  q.append('limit', limit);
  q.append('offset', offset);
  const res = await fetch(`${API_URL}/activities?${q.toString()}`, { headers: authHeaders() });
  return handleResponse(res);
};

export const activitySummary = async ({ ghg_category } = {}) => {
  const q = ghg_category != null ? `?ghg_category=${ghg_category}` : '';
  const res = await fetch(`${API_URL}/activities/summary${q}`, { headers: authHeaders() });
  return handleResponse(res);
};

export const deleteActivity = async (activityId) => {
  const res = await fetch(`${API_URL}/activities/${activityId}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return handleResponse(res);
};

export const reimportScope3Factors = async () => {
  const res = await fetch(`${BACKEND}/api/admin/scope3-factors/reimport`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: '{}',
  });
  return handleResponse(res);
};
